<template>
  <div class="UsersComponent DataTables">


    {{lang.infotext_1}}
    <br><br>
    <div :id="id"></div>
    <ContextMenuComponent :menu="menu" :id="name"></ContextMenuComponent>


    </div>
</template>
<script>

  //import {$, jQuery} from 'jquery'
  //datatable
  var $ = require('jquery');
  var jQuery = $
  window.$ = $
  window.jQuery = $
  var jquery = $;
  import 'bootstrap-vue/dist/bootstrap-vue.css'
  //var dt_extras = [
  require("datatables.net");
  require("datatables.net-bs4");
  require("datatables.net-colreorder-bs4");
  require("datatables.net-select-bs4");
  require("datatables.net-keytable");


  import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'

  import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'

  //pdfMake.vfs = pdfFonts.pdfMake.vfs;


  //import LoaderComponent from "@/components/shared/LoaderComponent"
  import ContextMenuComponent from "@/components/shared/ContextMenuComponent"
  import { mapGetters } from 'vuex'


    export default {
        name: "UsersComponent",
        props:{
          lang: Object,

        },
        components: {
          ContextMenuComponent
        },
        data () {
            return {
              name: "UsersComponent",
              id: "tableplace_"+this._uid,
                            
              contextMenu: {},
              //list of items in the context menu
              menu: [
                {id: "Edit", text: this.lang.contextmenu_text_Edit},
                {id: "Delete", text: this.lang.contextmenu_text_Delete},
              ],
              groups: [],
            }
        },
        computed: {

          ...mapGetters({
            
            globalSettings: 'globalSettings'
          }),

          reloadedAfterActionComplex(){
            return this.$store.getters.reloadedAfterActionComplex;
          },
          variant(){
            if (this.$store.getters.s_skinVariant == "dark"){
              return "light";
            }else{
              return "dark";
            }
            
          }
        },


        created () {
          this.getGroups();



        },
        watch: {
          reloadedAfterActionComplex: {
            handler: function (newValue) {

              for (let el in newValue) {

                if (newValue[el].name == this.name) {
                  if (newValue[el].status == true) {

                    this.getGroups(this);

                    newValue[el].status = false;
                    
                    this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
                  }
                }
              }
            },
            deep: true

          },
          
        },
        updated() {
          

        },
        mounted: function () {
         
          


        },
        methods: {
          getGroups() {
            
            let _vue = this;
            

            this.$store.dispatch("u_getGroups")
              .then(function (result) {

                console.log(result.data)

                if (result.status == "OK") {

                  if (result.data != null) {


                    for (let i = 0, lei = result.data.length; i < lei; i++) {
                      
                      _vue.groups = result.data;
                    }
                    _vue.getUsers(_vue);
                  }
                }




              })
          },
          groupIdToName(groupId) {
            let groupName = "";

            for (let i = 0, lei = this.groups.length; i < lei; i++){

              if (groupId == this.groups[i].groupId) {
                groupName = this.groups[i].groupName;
              }
            }


            return groupName;
          },
          getUsers(_vue){
      
            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_getUsers")
            .then(function(result) {
              
              console.log(result.data)

              _vue.$store.commit("USERSQUANTITY", result.data.length),
              _vue.buildTable(result.data);

            })
          },

          buildTable(datatable){
           

            var tableplace = document.getElementById("tableplace_"+this._uid);

            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            for(let i = 0, lei = datatable.length; i < lei; i++){

              datatable[i].actions = ""


            }



            var place = document.createElement("table");
            place.setAttribute("id", "place"+this._uid);
            place.setAttribute("class", "table table-striped table-bordered");
            place.setAttribute("style", "width:100%;");
            tableplace.appendChild(place)

            var tr1 = document.createElement("tr");
            tr1.setAttribute("class", "cellHeader");
            var thead = document.createElement("thead");
            thead.appendChild(tr1);
            place.appendChild(thead);

            var tr2 = document.createElement("tr");
            tr2.setAttribute("class", "cellFooter");
            var tfoot = document.createElement("tfoot");
            tfoot.appendChild(tr2);
            place.appendChild(tfoot);



            var columnDefs = [];

            let columns = [
              {
                name: "Id",
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_FirstName,
                alignInColumn: "center",

              },
              {
                name: this.lang.table_header_LastName,
                alignInColumn: "center",

              },
              {
                name: this.lang.table_header_Login,
                alignInColumn: "center",

              },
              {
                name: this.lang.table_header_Email,
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_Role,
                alignInColumn: "left",
              },
              {
                name: this.lang.table_header_Groups,
                alignInColumn: "left",
              },
              {
                name: this.lang.table_header_Active,
                alignInColumn: "left",
              },
              {
                name: this.lang.table_header_Actions,
                alignInColumn: "left",
              }
            ]

            let cols =  [
              { "data": "userId" },
              { "data": "FirstName" },
              { "data": "LastName" },
              { "data": "Login" },
              { "data": "Email" },
              { "data": "Role" },
              { "data": "groups" },
              { "data": "IsActive" },
              { "data": "actions" },

            ]

            let _vue = this;

            var len = columns.length;

            for (let i = 0; i < len; i++){



              var el = {};

              el = {
                targets: i,
                className: '_dt-body-'+ columns[i].alignInColumn,
                render: function ( data, type, row, meta ) {
                  if (data == null) {
                    data = "";
                  }

                  data = $.fn.dataTable.render.text().display(data);
                  if (data.display != undefined) {
                    data.display = $.fn.dataTable.render.text().display(data.display);
                  }


                  if (meta.col == 0){

                    return  data
                  }else if(meta.col == 1){



                    return data
                  }else if(meta.col == 2){
                    return  data;
                  }else if(meta.col == 3){




                    return  data;
                  }else if(meta.col == 4){



                    return  data;
                  }else if(meta.col == 5){

                    return data;
                  } else if (meta.col == 6) {

                    let str = "";

                    for (let i = 0, lei = data.length; i < lei; i++){
                      let variant = "orange";
                      let value = _vue.groupIdToName(data[i]);
                      if (value == "Admins") {
                        variant = "danger";
                      }
                      str += "<b-badge class='badge badge-"+variant+"'>"+ value +"</b-badge> ";
                    }

                    return str; 
                  } else if (meta.col == 7) {
                    let s = "<b-badge class='badge badge-danger'>inactive</b-badge>";
                    if (data == true) {
                      s = "<b-badge class='badge badge-success'>active</b-badge>";
                    } 
                    return  s;

                  }else if(meta.col == 8){




                    let str = "<button  class=\"btn btn-secondary btn-sm btn-"+_vue.variant+" button_action_edit\" id=\"button_confirm_" + row.userId +"\" >"+_vue.lang.button_Edit+"</button>";
                    //str += "<button  class=\"btn btn-secondary btn-sm btn-"+_vue.variant+" button_action_delete\" id=\"button_delete_" + row.userId +"\" >"+_vue.lang.button_Delete+"</button>";

                    return  str;
                  }


                }
              }



            columnDefs.push(el);

            const el1 = {
              
              targets: [7],
              orderData: [7, 2]
            }
            columnDefs.push(el1);
            const el2 = {
              targets: [2],
              orderData: [2, 7]
            }
            columnDefs.push(el2);

            const cols =  [
                  { "data": "userId" },
                  { "data": "FirstName" },
                  { "data": "LastName" },
                  { "data": "Login" },
                  { "data": "Email" },
                  { "data": "Role" },
                  { "data": "groups" },
                  { "data": "IsActive" },
                  { "data": "actions" },
                  
              ]

              var th1 = document.createElement("th");
              var th2 = document.createElement("th");
              tr1.appendChild(th1);
              tr2.appendChild(th2);
              //var p = document.createElement("p");
              //th.appendChild(p);

              var tx = document.createTextNode(columns[i].name)
              th1.appendChild(tx);

            }




            var json = {};


            json.keys = false;
            json.data= datatable;
            json.myColumnFormats = columns;
            json.colReorder = false;
            json.lengthMenu = [5];
            json.order = [[[7], "asc"]];
            json.select = false;/*{
                  style: 'os',
                  blurable: true
              }*/
            json.paging = false;
            json.columns = cols;

            json.columnDefs = columnDefs;

            json.dom = '<f<t>ip>';
            json.initComplete = function () {


            
          }
          json.fnDrawCallback = function( oSettings ) {
        
            _vue.buildContextMenu();
          }



                if ($.fn.dataTable.isDataTable('#place'+this._uid)) {
                    this.mainTable.destroy();

                }

                this.mainTable = $('#place'+this._uid).DataTable(json);
                this.mainTable.columns.adjust().draw();
                //columnDefs.push(this.mainTable);

                //hide first column in table
                this.mainTable.column(0).visible(false);
                if (_vue.globalSettings.advancedPermissions == false) {
                    this.mainTable.column(6).visible(false);
                }
                

                //search input change view
                var searchplace = document.getElementById("place"+this._uid+"_filter").firstChild

                while (searchplace.firstChild) {

                  if (searchplace.firstChild.textContent == "Search:"){
                      searchplace.removeChild(searchplace.firstChild);
                      break;
                  }

                }


                searchplace.firstChild.setAttribute("placeholder", "Enter search words")
                searchplace.firstChild.setAttribute("class", "form-control form-control-sm");
                searchplace.firstChild.addEventListener("input", function(evt){

                 _vue.$store.dispatch("setFilteredData", evt.target.value);

                })



              let buttons_action_props = document.getElementsByClassName('button_action_edit');


              for (var i = 0; i < buttons_action_props.length; i++) {
                buttons_action_props[i].addEventListener('click', function (vue){

                  var tr = $(this).closest('tr');
                  var row = _vue.mainTable.row( tr );

                  var data = row.data();

                  _vue.updateUser(data);



                }, false);
              }



              let buttons_action_delete = document.getElementsByClassName('button_action_delete');


              for (var i = 0; i < buttons_action_delete.length; i++) {
                buttons_action_delete[i].addEventListener('click', function (vue){




                  var tr = $(this).closest('tr');
                  var row = _vue.mainTable.row( tr );

                  var data = row.data();

                  _vue.deleteUser(data);

                  



                }, false);
              }







          },
          updateUser(_data){
            

            this.$store.dispatch(this.$store.getters.sectionPrefix + "_createUserForm", _data);

            let _vue = this;

            let funcYes = function(e){

              let form = _vue.$store.getters.createUserForm;

              let groups = [];
              for (let i = 0, lei = _vue.$store.getters.permissionGroup.length; i < lei; i++){
                groups.push(_vue.$store.getters.permissionGroup[i].groupId);
              }


              let obj = {
                userId: form.userId,
                firstName: form.FirstName,
                lastName: form.LastName,
                login: form.Login,
                newPassword: form.Password,
                email: form.Email,
                isActive: form.IsActive,
                role: form.Role,
                groups: groups
              }


              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_updateUserExt", obj)
              .then(function(result) {
                
                console.log(result)
            
                if (result.status == "OK") {
                  if (result.data != null) {
                    
                    //if (form.Password != undefined || form.Password != "") {

                      //reload table
                      const reloadObj = {
                        status: true,
                        name: "UsersComponent"
                      }
                      _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                      

                      // if (form.Password.length > 0) {


                      //   let obj = {
                      //     userId: form.userId,
                      //     newPassword: form.Password
                      //   }

                      //   _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_changePassword", obj)
                      //     .then(function (result) {
                      //       console.log(result)
                      //     })

                      // }
                    //}
                    let obj = {
                      text: _vue.lang.alert_success_UpdateUser,
                      time: 10,
                      type: "success"
                    }
                    _vue.$store.dispatch("displayFooterAlert", obj)

                    
                  } else {
                    let obj = {
                      text: _vue.lang.alert_error_UpdateUser + ": " + result.message,
                      time: 15,
                      type: "danger"
                    }

                    _vue.$store.dispatch("displayFooterAlert", obj)
                  }
                } else {
                  let obj = {
                    text: _vue.lang.alert_error_UpdateUser + ": " + result.message,
                    time: 15,
                    type: "danger"
                  }

                  _vue.$store.dispatch("displayFooterAlert", obj)
                }

                




              })

            }

            var obj = {
              
              text: "",
              type: "update_user",
              buttons: 2,
              size: "lm",
              lang: this.lang.modal_UpdateUser,
              funcNo: "",
              funcYes: funcYes
            };
            this.$store.dispatch("showModalComponent", obj);

          },
          deleteUser(data){

            let _vue = this;

            let objUser ={
              userId: data.userId,
              FirstName: data.FirstName,
              LastName: data.LastName,
              Login: data.Login,
              isActive: data.IsActive,
              Role: data.Role,
              groups: data.Groups
            }


            this.$store.dispatch("selectUser", objUser);

            let alert_success_DeleteUser = this.lang.alert_success_DeleteUser;
            let alert_error_DeleteUser = this.lang.alert_error_DeleteUser

      
            let funcYes = function (_vue){
               
              let obj = _vue.$store.getters.selectedUser

              
        
              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteUser", obj)
              .then(function(result) {
                
                console.log(result.data)

                if (result.status == "OK") {
                  if (result.data == 1) {

                    let obj = {
                      text: alert_success_DeleteUser,
                      time: 10,
                      type: "success"
                    }

                    _vue.$store.dispatch("displayFooterAlert", obj)


                    const reloadObj = {
                      status: true,
                      name: "UsersComponent"
                    }
                    _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                  } else {
                    let obj = {
                      text: alert_error_DeleteUser + ": " + result.message,
                      time: 15,
                      type: "danger"
                    }

                    _vue.$store.dispatch("displayFooterAlert", obj)
                  }
                } else {
                  let obj = {
                    text: alert_error_DeleteUser + ": " + result.message,
                    time: 15,
                    type: "danger"
                  }

                  _vue.$store.dispatch("displayFooterAlert", obj)
                }

                



              })
            }

            var obj = {
              title: "Delete user",
              text: "Are you sure?",
              type: "sure",
              buttons: 2,
              size: "sm",
              funcNo: "",
              funcYes: funcYes

            }
            this.$store.dispatch("showAlert", obj);
          },
          buildContextMenu(){
         

            var _vue = this;

            //context-menu
            var tableid = $("#place" + this._uid);

            $("#place" + this._uid + " tbody tr")
            .on("contextmenu", function(e) {
              
              let tr = $(this).closest('tr');
              let row = _vue.mainTable.row( tr );

              let data = row.data();

              _vue.contextMenu.row = data

              

              //methods in table component
              var updateUser = _vue.updateUser;
              var deleteUser = _vue.deleteUser;

              _vue.contextMenu.funcAction = function(_vue, action){

                //calling component methods depending on the context menu item clicked
                if (action == "Edit"){
                  updateUser(data);
                }
                if (action == "Delete"){
                  deleteUser(data);
                }
                

                return true;
              }

              var height = tableid.height();

              var offsetX = tableid.offset().left;
              var offsetY = tableid.offset().top;

              var top = e.clientY - offsetY + 100;
              var left = e.clientX - offsetX + 10;

              
              $("#context-menu-"+_vue.name).css({
                display: "block",
                top: top,
                left: left
              });
              return false; //blocks default Webbrowser right click menu
            })
            .on("click", function() {
              
              $("context-menu-"+_vue.name).hide();
            });

            $("#context-menu-"+_vue.name + " a").on("click", function() {
              
              $(this)
                .parent()
                .hide();
            });
            document.addEventListener('click', function(e){
              let clickInside = e.target.closest("#context-menu-"+_vue.name);
              
              if(clickInside == null){
                
                let contextMenu = document.getElementById("context-menu-"+_vue.name);
                if (contextMenu != null){
                  contextMenu.setAttribute('style', 'display:none');
                }
                                    
              }
            });
            //context-menu
          }
        }


    }
</script>
<style lang="scss">
.UsersComponent{

    table{
      width: 100%;
      font-size: 0.75rem;

    }

    table th {
      padding: 2px !important;

    }
    .table thead th {
        vertical-align:top;
        border-bottom: 3px solid;
    }
    table td {
      padding: 2px !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }
    .progress{
      width: 200px;

    }
    .dataTables_filter{
    float: left;
    font-size: 10px;
    }

    .dt-buttons{
      float: left;

      margin-left: 100px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .dt-button-collection{

      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;

    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .form-control {
      padding: 0.075rem 0.75rem;
    }
    .button_action_delete{
      margin: 2px 2px 2px 5px;
    }


  }

  .blackIcon{
    background: #333;
  }
  .badge{
    margin: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/UsersComponent.vue